export default __webpack_public_path__ + "static/media/boom_anim-02.cdffbf67.svg";